document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".site-header");
  const mobileNavToggle = document.querySelector(".mobile-nav-toggle");

  if (mobileNavToggle) {
    mobileNavToggle.addEventListener("click", () => {
      const isNavOpen = header.getAttribute("data-nav-open") === "true";
      header.setAttribute("data-nav-open", !isNavOpen);
    });
  }
});
